import React from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { useAppDispatch } from '../../../hooks/redux/hooks';
import { ProfileInformation, updateProfileInformation } from '../profileInformationsSlice';

interface Props {
  profile: ProfileInformation | null;
  isLoading: boolean;
}

type FormValues = {
    username: string;
    firstName: string;
    lastName: string;
    language?: string;
};

const ProfileInformationForm = (props: Props) => {
    const dispatch = useAppDispatch();
    const { handleSubmit, formState: { errors, isValid, isDirty }, register, reset } = useForm<FormValues>({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const submitHandler = (values: FormValues) => {
        dispatch(updateProfileInformation(values)); // removeEmptyFields(values);
        reset();
    }

    if(!props.profile || props.isLoading) {
        return <SmashSpinner />
    }

    return (
        <div>
            <Form noValidate onSubmit={handleSubmit(submitHandler)}>
                <Row>
                    <Col>
                        <Form.Group className="mb-3" controlId="firstName">
                            <Form.Control
                                {...register('firstName')}
                                type="text"
                                defaultValue={props.profile.firstName}
                                placeholder="First name"
                                isInvalid={!!errors.firstName}
                            />                            
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    
                    <Col>
                        <Form.Group className="mb-3" controlId="lastName">
                            <Form.Control
                                {...register('lastName')}
                                type="text"
                                placeholder="Last name"
                                defaultValue={props.profile.lastName}
                                isInvalid={!!errors.lastName}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>                    
                    <Col>
                        <Form.Group className="mb-3" controlId="username">
                            <Form.Control
                                {...register('username', { required: true })}
                                type="text"
                                defaultValue={props.profile.username}
                                placeholder="Your email"
                                isInvalid={!!errors.username}
                            />
                            {errors.username?.type === "required" && (
                                <Form.Control.Feedback type="invalid">
                                    Email is required
                                </Form.Control.Feedback>)}
                        </Form.Group>
                    </Col>
                </Row>
                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <Button disabled={!isDirty || !isValid} variant="primary" type="submit">
                        Save
                    </Button>
                </div>
            </Form> 
            {/* <p className="d-flex justify-content-between">Language: <strong>{identity?.language}</strong></p> */}
        </div>
    )
}

export default ProfileInformationForm